<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div
  class="max-w-1xl mx-auto bg-white p-8 flex flex-col gap-4 rounded-lg shadow-lg"
>
  <div class="flex flex-wrap pb-4 justify-start">
    <img
      [routerLink]="['/email-templates/manage']"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
    />
    <h1 *ngIf="!isEditable" class="headeradminui-text pl-2">
      Create Email Template
    </h1>
    <h1 *ngIf="isEditable" class="headeradminui-text pl-2">
      Update Email Template
    </h1>
  </div>
  <nz-spin [nzSpinning]="pageLoading">
    <div *ngIf="isEditable" nz-row class="pt-4" nzJustify="end">
      <div nz-col>
        <button
          [disabled]="!viewForm"
          (click)="enableEdit()"
          nz-button
          nzType="primary"
        >
          Edit Email Templates
        </button>
      </div>
    </div>
    <div class="flex gap-2">
      <div class="flex flex-col gap-4 w-1/2">
        <div class="grid grid-cols-1 gap-4">
          <div class="flex flex-col w-full">
            <label class="form-label">isVisible :</label>
            <nz-switch
              [nzDisabled]="isEditable && viewForm"
              [(ngModel)]="isVisible"
            ></nz-switch>
          </div>
        </div>
        <div class="grid grid-rows">
          <div class="flex flex-col w-full">
            <label class="form-label required">Title :</label>
            <input
              nz-input
              placeholder="enter title"
              [disabled]="isEditable && viewForm"
              [(ngModel)]="templateName"
              type="text"
            />
          </div>
          <div class="flex flex-col w-full">
            <label class="form-label required">Subject : </label>
            <input
              nz-input
              placeholder="enter subject"
              [disabled]="isEditable && viewForm"
              [(ngModel)]="subject"
              type="text"
              required
            />
          </div>
          <div>
            <label>Banner Image</label>
            <input nz-input type="file" (change)="onFileSelected($event)" />
          </div>
          <div class="flex flex-col w-full">
            <label class="form-label required">Body :</label>
            <textarea
              nz-input
              rows="4"
              placeholder="enter body"
              (ngModelChange)="bodyChange($event)"
              [disabled]="isEditable && viewForm"
              [(ngModel)]="body"
              type="text"
            ></textarea>
            <div class="flex flex-col w-full">
              <label class="form-label required"
                >Call-to-action button Text :</label
              >
              <input
                nz-input
                placeholder="Enter cta button text"
                [disabled]="isEditable && viewForm"
                [(ngModel)]="ctaButtonText"
                rows="4"
              />
            </div>
            <div class="flex flex-col w-full">
              <label class="form-label required"
                >Call-to-action button Link :
              </label>
              <input
                nz-input
                placeholder="enter cta button link"
                [disabled]="isEditable && viewForm"
                [(ngModel)]="ctaButtonLink"
                type="text"
                required
              />
            </div>
            <div class="flex flex-col w-full">
              <label class="form-label required">Footer Message : </label>
              <input
                nz-input
                placeholder="enter subject"
                [disabled]="isEditable && viewForm"
                [(ngModel)]="footerMessage"
                type="text"
                required
              />
            </div>
          </div>
          <div class="w-full flex flex-col gap-2 my-2">
            <img
              class="object-cover h-40 w-40"
              [src]="thumbnailUrl"
              alt="thumbnail"
            />
            <label>Thumbnail Image</label>
            <input
              nz-input
              type="file"
              (change)="onThumbnailSelected($event)"
            />
          </div>
          <div>
            <label class="form-label required">Selected Tags:</label>
            <!-- <nz-select
            (ngModelChange)="selectTag($event)"
            nzPlaceHolder="Please select tag"
            [(ngModel)]="tags"
            nzMode="multiple"
            nzShowSearch
            [nzDisabled]="isEditable"
          >
            <nz-option
              *ngFor="let ex of allTags"
              [nzValue]="ex.value"
              [nzLabel]="ex.data"
            ></nz-option>
          </nz-select> -->
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedTags"
              [nzDropdownRender]="renderTemplate"
              nzPlaceHolder="custom dropdown render"
              nzMode="multiple"
            >
              @for (item of tags; track item) {
                <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
              }
            </nz-select>
            <ng-template #renderTemplate>
              <nz-divider class="my-2"></nz-divider>
              <div class="flex items-center gap-2 px-3 py-2">
                <input
                  type="text"
                  nz-input
                  #inputElement
                  class="flex-1 min-w-0"
                />
                <a
                  class="text-blue-600 hover:text-blue-800 cursor-pointer flex items-center gap-1"
                  (click)="addItem(inputElement)"
                >
                  <span nz-icon nzType="plus"></span>
                  Add item
                </a>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-4">
          <div class="flex flex-col w-full">
            <label class="form-label required">All Partners :</label>
            <nz-switch
              [nzDisabled]="isEditable && viewForm"
              [(ngModel)]="allPartners"
            ></nz-switch>
          </div>
          <!-- <div class="flex flex-col w-full">
            <label class="form-label required">Few Partners :</label>
            <nz-switch
              [nzDisabled]="isEditable && viewForm"
              [(ngModel)]="fewPartners"
            ></nz-switch>
          </div> -->
        </div>
        <div *ngIf="!allPartners" class="grid grid-cols-1 gap-4">
          <div class="flex flex-col w-full">
            <label class="form-label">Applicable Partners:</label>
            <nz-select
              nzMode="multiple"
              nzPlaceHolder="Please select partners"
              [(ngModel)]="listOfSelectedValue"
              [nzDisabled]="isEditable && viewForm"
            >
              <nz-option
                *ngFor="let partner of partners"
                [nzValue]="partner.value"
                [nzLabel]="partner.data"
              ></nz-option>
            </nz-select>
          </div>
        </div>
        <div class="flex gap-2 items-end justify-end">
          <div>
            <button
              *ngIf="!isEditable"
              (click)="createAsDraft()"
              nz-button
              nzDanger
            >
              Save Template as Draft
            </button>
            <button
              *ngIf="isEditable"
              [disabled]="isEditable && viewForm"
              (click)="updateAsDraft()"
              nz-button
              nzDanger
            >
              Update Template as Draft
            </button>
          </div>
          <div nz-col>
            <button
              *ngIf="isEditable"
              [disabled]="isEditable && viewForm"
              (click)="updatePublished()"
              nz-button
              nzType="primary"
            >
              Publish Template
            </button>
            <button
              *ngIf="!isEditable"
              (click)="createPublished()"
              nz-button
              nzType="primary"
            >
              Publish Template
            </button>
          </div>
        </div>
      </div>
      <div class="rounded-2xl bg-gray-50 border-gray-1 p-4">
        <!-- email-template.component.html -->
        <table
          width="100%"
          cellpadding="0"
          cellspacing="0"
          border="0"
          style="
            font-family: sans-serif;
            background-color: #f4f4f4;
            padding: 20px;
          "
        >
          <tr>
            <td align="center">
              <table
                width="600"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  background-color: #ffffff;
                  border-radius: 8px;
                  overflow: hidden;
                "
              >
                <!-- Header -->
                <tr>
                  <td style="padding: 20px; font-size: 20px; font-weight: bold">
                    {{ templateName }}
                  </td>
                </tr>

                <!-- Banner Image -->
                <tr align="center">
                  <td>
                    <img
                      src="{{ previewBannerUrl }}"
                      alt="Banner"
                      width="538.9440307617188"
                      height="192.67250061035156"
                      style="display: block; max-width: 100%; object-fit: cover"
                    />
                  </td>
                </tr>

                <!-- Title -->
                <!-- <tr>
                  <td
                    style="
                      padding: 20px 20px 0 20px;
                      font-size: 18px;
                      font-weight: bold;
                    "
                  >
                    {{ templateName }}
                  </td>
                </tr> -->

                <!-- Body Content -->
                <tr>
                  <!-- <td  style="padding: 10px 20px; font-size: 14px; color: #333">
                    {{ body }}
                  </td> -->
                  <td
                    style="padding: 10px 20px; font-size: 14px; color: #333"
                    [innerHTML]="safeBodyContent"
                  ></td>
                </tr>

                <!-- CTA Button -->
                <tr>
                  <td align="center" style="padding: 20px">
                    <a
                      target="_blank"
                      href="{{ ctaButtonLink }}"
                      style="
                        background-color: #11114e;
                        color: white;
                        text-decoration: none;
                        padding: 12px 24px;
                        border-radius: 6px;
                        display: inline-block;
                      "
                    >
                      {{ ctaButtonText }}
                    </a>
                  </td>
                </tr>

                <!-- Footer Message -->
                <tr>
                  <td style="padding: 20px; font-size: 12px; color: #666">
                    {{ footerMessage }}
                  </td>
                </tr>
                <!-- Footer Section -->
                <table
                  width="100%"
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="background-color: #e6ddff; padding: 20px 0"
                >
                  <tr>
                    <td align="center">
                      <table
                        width="600"
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                      >
                        <tr>
                          <!-- Social Icons -->
                          <td align="left" style="padding: 0 20px">
                            <a style="cursor: pointer; margin-right: 10px"
                              ><img
                                src="https://cdn.anyo.app/mail-assets/mdi_linkedin.png"
                                alt="Instagram"
                                width="32"
                                style="display: inline-block"
                            /></a>
                            <a
                              href="https://www.linkedin.com/company/anyo-app/?viewAsMember=true"
                              ><img
                                width="32"
                                src="https://cdn.anyo.app/mail-assets/hugeicons_instagram.png"
                                alt="LinkedIn"
                                style="display: inline-block"
                            /></a>
                          </td>

                          <!-- App Store Buttons -->
                          <td align="right" style="padding: 20px">
                            <table cellpadding="0" cellspacing="0" border="0">
                              <tr>
                                <!-- App Store Button -->
                                <td style="padding-right: 10px">
                                  <a
                                    href="https://itunes.apple.com/app/6449729164"
                                    target="_blank"
                                    style="text-decoration: none"
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      style="
                                        border: 1px solid #9b88f9;
                                        border-radius: 12px;
                                        background-color: transparent;
                                        padding: 0;
                                        border-collapse: separate;
                                      "
                                    >
                                      <tr>
                                        <td
                                          style="
                                            padding: 10px 14px;
                                            border-radius: 12px;
                                          "
                                        >
                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            border="0"
                                          >
                                            <tr>
                                              <td>
                                                <img
                                                  src="https://cdn.anyo.app/mail-assets/icons8-apple-logo.png"
                                                  alt="App Store"
                                                  width="36"
                                                  height="36"
                                                  style="display: block"
                                                />
                                              </td>
                                              <td style="padding-left: 10px">
                                                <div
                                                  style="
                                                    font-size: 12px;
                                                    font-weight: 700;
                                                    text-transform: uppercase;
                                                    color: #9b88f9;
                                                    line-height: 1.2;
                                                  "
                                                >
                                                  Download on the
                                                </div>
                                                <div
                                                  style="
                                                    font-size: 16px;
                                                    font-weight: 400;
                                                    color: #9b88f9;
                                                    line-height: 1.5;
                                                  "
                                                >
                                                  App Store
                                                </div>
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  </a>
                                </td>

                                <!-- Google Play Button -->
                                <td style="padding-right: 10px">
                                  <a
                                    href="https://play.google.com/store/apps/details?id=app.anyo.com"
                                    target="_blank"
                                    style="text-decoration: none"
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      style="
                                        border: 1px solid #9b88f9;
                                        border-radius: 12px;
                                        background-color: transparent;
                                        padding: 0;
                                        border-collapse: separate;
                                      "
                                    >
                                      <tr>
                                        <td
                                          style="
                                            padding: 10px 14px;
                                            border-radius: 12px;
                                          "
                                        >
                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            border="0"
                                          >
                                            <tr>
                                              <td>
                                                <img
                                                  src="https://cdn.anyo.app/mail-assets/icons8-play-store.png"
                                                  alt="Play Store"
                                                  width="36"
                                                  height="36"
                                                  style="display: block"
                                                />
                                              </td>
                                              <td style="padding-left: 10px">
                                                <div
                                                  style="
                                                    font-size: 12px;
                                                    font-weight: 700;
                                                    text-transform: uppercase;
                                                    color: #9b88f9;
                                                    line-height: 1.2;
                                                  "
                                                >
                                                  Download on the
                                                </div>
                                                <div
                                                  style="
                                                    font-size: 16px;
                                                    font-weight: 400;
                                                    color: #9b88f9;
                                                    line-height: 1.5;
                                                  "
                                                >
                                                  Play Store
                                                </div>
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </nz-spin>
</div>
